export enum ChangeRequestStatus {
    Potential = 'Potential',
    Pending = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected',
}

export const ChangeRequestStatusLabels: Record<ChangeRequestStatus | string, string> = {
    Potential: 'Potential',
    Pending: 'Pending',
    Approved: 'Approved',
    Rejected: 'Rejected',
};
